@use "../../theme/colors";

.container {
	width: 100%;
	flex: 1 0 auto;
	box-sizing: border-box;
}

.contentContainer {
	border-bottom: 2px solid colors.$color-blue;
}

.textContainer {
	display: flex;
}

.title {
	font-size: 35px;
	text-align: center;
	font-weight: 500;
	width: 500px;
	margin: 0 auto 24px;
	line-height: 1.2em;
}

.img {
	margin-top: 50px;
}

.imageContainer {
	margin: 30px;
	box-sizing: border-box;
}

.MobileBtns {
	margin-right: 30px;
}

.links {
	margin-bottom: 32px;
}

@media screen and (max-width: 480px) {

	.textContainer {
		flex-direction: column;
		padding: 0 20px;
		margin-bottom: 20px;
	}

	.title {
		font-size: 21px;
		width: auto;
	}

	.links {
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.links a:first-of-type {
		margin-bottom: 25px;
	}

	.links a button {
		margin: 0;
	}

	.imageContainer {
		order: -1;
		display: flex;
		width: 100%;
		justify-content: center;
		margin: 0;
		margin-bottom: 30px;
	}

	.img {
		margin: 0;
		width: 250px;
		height: 230px;
	}

	.mobileMap {
		display: none;
	}
}
